'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalAdControl = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger*/


var DEFAULT_IFRAME_URL = 'about:blank';

/**
 * LocalAd Component responsible for rendering a local ad Unit
 * @class  LocalAd
 */

var LocalAdControl = exports.LocalAdControl = function (_React$Component) {
  _inherits(LocalAdControl, _React$Component);

  function LocalAdControl(props) {
    _classCallCheck(this, LocalAdControl);

    var _this = _possibleConstructorReturn(this, (LocalAdControl.__proto__ || Object.getPrototypeOf(LocalAdControl)).call(this, props));

    _this.state = {};
    _this.UpperRandomLimit = 999999;
    _this.setControlRef = _this.setControlRef.bind(_this);
    _this.defaultIframeUrl = '/obituaries/AffiliateAdvertisement.axd?affiliate=' + _this.props.affiliateSiteName + '&adid=2&preview=False&adtype=1&v=20160607';
    return _this;
  }

  /**
   * refreshAd - description
   *
   * @return {type}  description
   */


  _createClass(LocalAdControl, [{
    key: 'refreshAd',
    value: function refreshAd() {
      var frameSrc = this.adControl.src === DEFAULT_IFRAME_URL ? this.defaultIframeUrl : this.adControl.src;

      if (frameSrc && frameSrc.indexOf('rand=') >= 0) {
        frameSrc = frameSrc.substring(0, frameSrc.indexOf('rand='));
      }
      frameSrc = frameSrc + '&rand=' + Math.floor(Math.random() * this.UpperRandomLimit);
      this.adControl.src = frameSrc;
    }

    /**
     * unloadAd - Remove the current ad content from DOM
     *
     * @return {Undefined} Returns nothing
     */

  }, {
    key: 'unloadAd',
    value: function unloadAd() {
      if (this.adControl) {
        this.adControl.src = DEFAULT_IFRAME_URL;
      }
    }

    /**
     * setControlRef - function to assign reference to local ad component
     *
     * @param  {object} adControl iframe reference
     * @return {Undefined} Returns nothing.
     */

  }, {
    key: 'setControlRef',
    value: function setControlRef(adControl) {
      if (adControl) {
        this.adControl = adControl;
      }
    }

    /**
     * Renders Component
     * @return {JSX} Rendered ResultsHeader Component
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('iframe', { ref: this.setControlRef,
          allowTransparency: 'true',
          scrolling: 'no',
          height: '' + this.props.height,
          width: '' + this.props.width,
          frameBorder: '0',
          src: this.defaultIframeUrl })
      );
    }
  }]);

  return LocalAdControl;
}(_react2.default.Component);

LocalAdControl.propTypes = {
  affiliateSiteName: _propTypes2.default.string,
  height: _propTypes2.default.number,
  width: _propTypes2.default.number
};
LocalAdControl.defaultProps = {
  width: 300,
  height: 250
};
exports.default = LocalAdControl;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/legacy-advertising/dist/Component/LocalAdControl.js
// module id = 599
// module chunks = 0